import React from "react";
import PhoneNumbers from "./phoneNumbers";
import Email from "./email";
import Website from "./website";
import PersonAndTitle from "./personAndTitle";
import CompanyName from "./companyName";
import Address from "./address";
import Logo from "./logo";

// PhoneIQ design-system-v2 tokens (https://www.phoneiq.co/brand-guide).
// Email-safe subset: hex colors only, system font stacks, no CSS variables.
// Spacing, sizes, and row order match the legacy signature so the refresh
// feels identical at a glance; only brand substance changed.
const fontFamily =
  '"Helvetica Neue", Inter, "Neue Haas Grotesk Display", Helvetica, Arial, system-ui, sans-serif';
const colors = {
  ink: "#14171a",
  quiet: "#626a70",
  signal: "#5e55fd",
  rule: "#eceeeb",
};

export default function Signature({ formData }) {
  const {
    logo,
    title,
    officePhone,
    mobilePhone,
    email,
    companyName,
    name,
    addressLineOne,
    addressLineTwo,
    addressState,
    addressCity,
    addressZip,
    website,
  } = formData;

  return (
    <section className="email-signature" data-clipboard-target>
      <table
        id="emailSignature"
        cellPadding={0}
        cellSpacing={0}
        role="presentation"
        width={550}
        className="wrapper"
      >
        <tbody>
          <tr>
            <td style={{ padding: "0 0 16px 0" }}>
              <table
                cellPadding={0}
                cellSpacing={0}
                role="presentation"
                width="100%"
              >
                <tbody>
                  <tr>
                    <td
                      height="1"
                      bgcolor={colors.rule}
                      style={{
                        height: 1,
                        fontSize: 0,
                        lineHeight: 0,
                        backgroundColor: colors.rule,
                      }}
                    >
                      &nbsp;
                    </td>
                  </tr>
                </tbody>
              </table>
            </td>
          </tr>
          <tr>
            <td>
              <table cellPadding={0} cellSpacing={0} role="presentation">
                <tbody>
                  <tr>
                    {logo && <Logo logo={logo} />}
                    <td valign="top" width="100%">
                      <table
                        cellPadding={0}
                        cellSpacing={0}
                        role="presentation"
                      >
                        <tbody>
                          {name && title && (
                            <PersonAndTitle
                              fontFamily={fontFamily}
                              colors={colors}
                              {...formData}
                            />
                          )}
                          {(officePhone || mobilePhone) && (
                            <PhoneNumbers
                              fontFamily={fontFamily}
                              colors={colors}
                              mobilePhone={mobilePhone}
                              officePhone={officePhone}
                            />
                          )}
                          {email && (
                            <Email
                              fontFamily={fontFamily}
                              colors={colors}
                              {...formData}
                            />
                          )}
                          {companyName && (
                            <CompanyName
                              fontFamily={fontFamily}
                              colors={colors}
                              {...formData}
                            />
                          )}
                          {(addressLineOne ||
                            addressLineTwo ||
                            addressState ||
                            addressCity ||
                            addressZip) && (
                            <Address
                              fontFamily={fontFamily}
                              colors={colors}
                              address={formData}
                            />
                          )}
                          {website && (
                            <Website
                              fontFamily={fontFamily}
                              colors={colors}
                              {...formData}
                            />
                          )}
                        </tbody>
                      </table>
                    </td>
                  </tr>
                </tbody>
              </table>
            </td>
          </tr>
        </tbody>
      </table>
    </section>
  );
}
